import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { accountLogoutStart } from '../../redux/account';
import { selectControls } from '../../redux/controls';
import { ON_DEV } from '../../shared';
import { LoggedInMenuProps } from './models/LoggedInMenu.interfaces';
import {ReactComponent as DeleteIcon} from '../../images/nde-icon-delete.svg';
import './LoggedInMenu.scss';
import { useNavigate } from 'react-router';


export const LoggedInMenu = ({
  show=false,
  showCallback,
  showChangePasswordCallback,
  showDeleteAccountCallback,
  showRosterCallback
}: LoggedInMenuProps): JSX.Element => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const firstButtonRef = useRef<HTMLButtonElement>(null);

  const controls = useSelector(selectControls);

  const logout = useCallback(() => {
    dispatch(accountLogoutStart());
    showCallback(false);
  }, [dispatch, showCallback]);

  // changed first button to be close button for keyboard access
  useEffect(() => {
    if (show && firstButtonRef.current) {
      firstButtonRef.current.focus();
    }
  }, [show]);

  return (
    <nav className={`nqt-nav nqt-logged-in-menu${show ? '' : ' d-none'}`}>
      <header className="nqt-blue-header">
        <h3 className="nqt-blue-header--title">{controls?.LoginPUHeader?.controlText}</h3>
        <button className='nqt-modal--close-button'
          type='button'
          ref={firstButtonRef}
          onClick={() => showCallback(false)}>
          <DeleteIcon/>
          <span className="visually-hidden">{controls?.ModalClose?.controlText}</span>
        </button>
      </header>
      <section className="nqt-logged-in-menu--list-container container-fluid p-0">
        <ul className="nqt-logged-in-menu--list row row-cols-1 m-0 p-0">
          {
            ON_DEV &&
            <button className="nqt-button-link nqt-logged-in-menu--item col"
              onClick={() => {showDeleteAccountCallback && showDeleteAccountCallback(true); showCallback(false);}}>{controls?.LoginDelete?.controlText}</button>
          }
          <button className="nqt-button-link nqt-logged-in-menu--item col"
            onClick={() => {navigate('/testresults'); showCallback(false);}}>{controls?.LoginPUResults?.controlText}</button>
          <button className="nqt-button-link nqt-logged-in-menu--item col"
            onClick={() => {showRosterCallback(true); showCallback(false);}}>{controls?.LoginPUManageRosters?.controlText}</button>
          <button className="nqt-button-link nqt-logged-in-menu--item col"
            onClick={() => {showChangePasswordCallback(true); showCallback(false);}}>{controls?.LoginPUChangePassword?.controlText}</button>
          <button className="nqt-button-link nqt-logged-in-menu--item col"
            onClick={logout}>{controls?.LoginPULogout?.controlText}</button>
        </ul>
      </section>
    </nav>
  );
};

export default LoggedInMenu;